/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Log_In_Legacy_ContentInputs */

const en_dialog_log_in_legacy_content = /** @type {(inputs: Dialog_Log_In_Legacy_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To ensure the secure preservation of your subscription data, we will guide you to create a Seekr ID and link it to your current Forest data.`)
};

const ar_dialog_log_in_legacy_content = /** @type {(inputs: Dialog_Log_In_Legacy_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لضمان الحفاظ الآمن على بيانات اشتراكك، سنرشدك لإنشاء معرف سيكر ورابط ببيانات Forest الحالية الخاصة بك.`)
};

const de_dialog_log_in_legacy_content = /** @type {(inputs: Dialog_Log_In_Legacy_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um die sichere Aufbewahrung Ihrer Abonnementdaten zu gewährleisten, leiten wir Sie an, eine Seekr ID zu erstellen und diese mit Ihren aktuellen Walddaten zu verknüpfen.`)
};

const es_dialog_log_in_legacy_content = /** @type {(inputs: Dialog_Log_In_Legacy_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para garantizar la conservación segura de tus datos de suscripción, te guiaremos para crear un ID de Seekr y vincularlo a tus datos actuales de Forest.`)
};

const fr_dialog_log_in_legacy_content = /** @type {(inputs: Dialog_Log_In_Legacy_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pour assurer la conservation sécurisée de vos données d'abonnement, nous vous aiderons à créer un Seekr ID et à le relier à vos données Forest actuelles.`)
};

const it_dialog_log_in_legacy_content = /** @type {(inputs: Dialog_Log_In_Legacy_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Per garantire la conservazione sicura dei dati del tuo abbonamento, ti guideremo nella creazione di un ID Seeker e nel suo collegamento ai tuoi dati Forest attuali.`)
};

const ja_dialog_log_in_legacy_content = /** @type {(inputs: Dialog_Log_In_Legacy_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サブスクリプションデータを安全に保存するため、Seekr IDを作成して現在のForestデータとリンクさせる方法をご案内いたします。`)
};

const ko_dialog_log_in_legacy_content = /** @type {(inputs: Dialog_Log_In_Legacy_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`구독 데이터를 안전하게 보존하기 위해 Seekr ID를 생성하고 현재 Forest 데이터에 연결하도록 안내해 드려요.`)
};

const pt_br_dialog_log_in_legacy_content = /** @type {(inputs: Dialog_Log_In_Legacy_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para garantir a preservação e proteção dos dados da sua assinatura, nos ajudaremos você a criar um Seekr ID e vinculá-lo aos seus dados do Forest.`)
};

const ru_dialog_log_in_legacy_content = /** @type {(inputs: Dialog_Log_In_Legacy_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Чтобы обеспечить безопасное сохранение данных о подписке, мы поможем вам создать Seekr ID и связать его с вашими текущими данными Forest.`)
};

const th_dialog_log_in_legacy_content = /** @type {(inputs: Dialog_Log_In_Legacy_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เพื่อให้แน่ใจว่าข้อมูลการสมัครสมาชิกของคุณได้รับการปกป้องอย่างปลอดภัย เราจะแนะนำให้คุณสร้าง Seekr ID และเชื่อมโยงมันเข้ากับข้อมูล Forest ปัจจุบันของคุณ`)
};

const tr_dialog_log_in_legacy_content = /** @type {(inputs: Dialog_Log_In_Legacy_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonelik verilerinin güvenli bir şekilde korunmasını sağlamak adına bir Seekr ID oluşturman ve bunu mevcut Forest verilerine bağlaman için sana rehberlik edeceğiz.`)
};

const zh_cn_dialog_log_in_legacy_content = /** @type {(inputs: Dialog_Log_In_Legacy_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为确保你的 Plus 会员数据安全保存，我们将引导你创建 Seekr ID 并与当前的 Forest 数据连结。`)
};

const zh_tw_dialog_log_in_legacy_content = /** @type {(inputs: Dialog_Log_In_Legacy_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`為確保你的訂閱資料安全保存，我們將引導你建立 Seekr ID 並和當前的 Forest 資料連結。`)
};

/**
* | output |
* | --- |
* | "To ensure the secure preservation of your subscription data, we will guide you to create a Seekr ID and link it to your current Forest data." |
*
* @param {Dialog_Log_In_Legacy_ContentInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const dialog_log_in_legacy_content = /** @type {((inputs?: Dialog_Log_In_Legacy_ContentInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Log_In_Legacy_ContentInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dialog_log_in_legacy_content(inputs)
	if (locale === "ar") return ar_dialog_log_in_legacy_content(inputs)
	if (locale === "de") return de_dialog_log_in_legacy_content(inputs)
	if (locale === "es") return es_dialog_log_in_legacy_content(inputs)
	if (locale === "fr") return fr_dialog_log_in_legacy_content(inputs)
	if (locale === "it") return it_dialog_log_in_legacy_content(inputs)
	if (locale === "ja") return ja_dialog_log_in_legacy_content(inputs)
	if (locale === "ko") return ko_dialog_log_in_legacy_content(inputs)
	if (locale === "pt_br") return pt_br_dialog_log_in_legacy_content(inputs)
	if (locale === "ru") return ru_dialog_log_in_legacy_content(inputs)
	if (locale === "th") return th_dialog_log_in_legacy_content(inputs)
	if (locale === "tr") return tr_dialog_log_in_legacy_content(inputs)
	if (locale === "zh_cn") return zh_cn_dialog_log_in_legacy_content(inputs)
	return zh_tw_dialog_log_in_legacy_content(inputs)
});